<form clrForm [formGroup]="paidForm" clrLayout="horizontal" novalidate>
  <clr-input-container>
    <label>eingegangener Betrag (in Euro)</label>
    <input clrInput type="currency" id="amountPaid" formControlName="amountPaid" />
    <clr-control-helper>Der eingegebene Wer darf nicht größer als der Bruttowert der Rechnung sein.</clr-control-helper>
    <clr-control-error>Bitte prüfen Sie den eingegebenen Wert (nur Zahlen sowie Punkt oder Komma sind erlaubt).</clr-control-error>
  </clr-input-container>
  <clr-date-container>
    <label>Datum:</label>
    <input clrDate type="date" placeholder="{{ paidDate | date: 'dd.MM.yyyy' }}" formControlName="paidDate" />
    <span  class="btn-group btn-primary btn-icon">
  </span>
  </clr-date-container>

  <p class="btn-group btn-primary btn-icon">
    <button class="btn btn-sm" (click)="updatedSaldo()" [disabled]="paidForm.invalid">
      <cds-icon shape="floppy"></cds-icon>
      <span class="clr-icon-title">Speichern</span>
    </button>
  </p>
</form>
